import React, { useEffect } from 'react';
import PropTypes from 'prop-types'

import Revenue from '../../images/revenue.svg'
import BookedTickets from '../../images/booked-tickets.svg'
import BookedSeats from '../../images/booked-seat.svg'
import CancelledSeats from '../../images/cancelled-seats.svg'

const TicketDetails = ({ otherDetails, lastUpdated='' }) => (
  <React.Fragment>
    <div>
      <span className="db-card-title">Today's Sale</span>
      <span className="db-last-updated">Last Updated: {lastUpdated}</span>
    </div>
    <div className="row db-card-wrp db-border-bottom">
      <div className="col-xs-3">
        <div className="db-card">
          <p className="db-card-header"><img src={Revenue} alt="Revenue" /> Revenue</p>
          <div className="db-card-body">
            &#8377; {otherDetails.total_sales || 0}
          </div>
        </div>
      </div>
      <div className="col-xs-3">
        <div className="db-card">
          <p className="db-card-header"><img src={BookedTickets}  alt="Booked Tickets" /> Booked Tickets</p>
          <div className="db-card-body">
            {otherDetails.journey_count|| 0}
          </div>
        </div>
      </div>
      <div className="col-xs-3">
        <div className="db-card">
          <p className="db-card-header"><img src={BookedSeats} alt="Booked Seats" /> Booked Seats</p>
          <div className="db-card-body">
            {otherDetails.tickets_count || 0}
          </div>
        </div>
      </div>
      <div className="col-xs-3">
        <div className="db-card">
          <p className="db-card-header"><img src={CancelledSeats} alt="Cancelled Seats" /> Cancelled Seats</p>
          <div className="db-card-body">
            {otherDetails.cancellations_count || 0}
          </div>
        </div>
      </div>
    </div>
  </React.Fragment>
)

TicketDetails.propTypes = {
  otherDetails: PropTypes.shape({
    total_sales: PropTypes.number,
    tickets_count: PropTypes.number,
    cancellations_count: PropTypes.number
  }),
};

export default TicketDetails;
